import { ShieldCheck } from 'lucide-react';

interface AgentRlsBadgeProps {
    hasRls: boolean;
}

export function AgentRlsBadge({ hasRls }: AgentRlsBadgeProps) {
    if (!hasRls) return null;

    return (
        <div className="flex items-center gap-1.5 bg-green-50 dark:bg-green-950/40 p-1.5 pr-3 pl-2 border border-green-100 dark:border-green-900 border-rounded rounded-full w-fit font-medium text-xs">
            <ShieldCheck strokeWidth={1.5} className="size-4! text-green-950 dark:text-green-200" />
            <span className="text-green-950/80 dark:text-green-200/80">Row-level security</span>
        </div>
    );
}
